import { useState } from "react";
import Awards from "./Awards";
import AwardPeriods from "./AwardPeriods";

const AwardsTab = () => {
    const [activeTab, setActiveTab] = useState("awardPeriods");

    return (
        <>
            {/* Tab Navigation */}
            <div style={{ 
                borderBottom: "1px solid #e5e7eb", 
                marginBottom: "0",
                overflowX: "auto",
                scrollbarWidth: "none",
                msOverflowStyle: "none"
            }}>
                <div style={{ 
                    display: "flex", 
                    gap: "0",
                    minWidth: "max-content",
                    padding: "0 6px"
                }}>
                    <button
                        type="button"
                        onClick={() => setActiveTab("awardPeriods")}
                        style={{
                            background: "none",
                            border: "none",
                            padding: window.innerWidth < 400 ? "10px 12px" : "12px 20px",
                            fontWeight: activeTab === "awardPeriods" ? 600 : 400,
                            color: activeTab === "awardPeriods" ? "#17b0a7" : "#6b7280",
                            borderBottom: activeTab === "awardPeriods" ? "2px solid #17b0a7" : "2px solid transparent",
                            cursor: "pointer",
                            fontSize: window.innerWidth < 400 ? "0.8rem" : "0.9rem",
                            transition: "all 0.2s ease",
                            marginBottom: "-1px",
                        }}
                    >
                        Award Periods
                    </button>
                    <button
                        type="button"
                        onClick={() => setActiveTab("awards")}
                        style={{
                            background: "none",
                            border: "none",
                            padding: window.innerWidth < 400 ? "10px 12px" : "12px 20px",
                            fontWeight: activeTab === "awards" ? 600 : 400,
                            color: activeTab === "awards" ? "#17b0a7" : "#6b7280",
                            borderBottom: activeTab === "awards" ? "2px solid #17b0a7" : "2px solid transparent",
                            cursor: "pointer",
                            fontSize: window.innerWidth < 400 ? "0.8rem" : "0.9rem",
                            transition: "all 0.2s ease",
                            marginBottom: "-1px",
                        }}
                    >
                        Awards
                    </button>
                </div>
            </div>

            {/* Tab Content — full width */}
            <div>
                {activeTab === "awardPeriods" && <AwardPeriods />}
                {activeTab === "awards" && <Awards />}
            </div>
        </>
    );
};

export default AwardsTab;